import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { EditorAction, registerEditorAction, registerEditorContribution } from '../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';

var CursorState = /*#__PURE__*/function () {
  function CursorState(selections) {
    _classCallCheck(this, CursorState);

    this.selections = selections;
  }

  _createClass(CursorState, [{
    key: "equals",
    value: function equals(other) {
      var thisLen = this.selections.length;
      var otherLen = other.selections.length;

      if (thisLen !== otherLen) {
        return false;
      }

      for (var i = 0; i < thisLen; i++) {
        if (!this.selections[i].equalsSelection(other.selections[i])) {
          return false;
        }
      }

      return true;
    }
  }]);

  return CursorState;
}();

var StackElement = function StackElement(cursorState, scrollTop, scrollLeft) {
  _classCallCheck(this, StackElement);

  this.cursorState = cursorState;
  this.scrollTop = scrollTop;
  this.scrollLeft = scrollLeft;
};

export var CursorUndoRedoController = /*#__PURE__*/function (_Disposable) {
  _inherits(CursorUndoRedoController, _Disposable);

  var _super = _createSuper(CursorUndoRedoController);

  function CursorUndoRedoController(editor) {
    var _this;

    _classCallCheck(this, CursorUndoRedoController);

    _this = _super.call(this);
    _this._editor = editor;
    _this._isCursorUndoRedo = false;
    _this._undoStack = [];
    _this._redoStack = [];

    _this._register(editor.onDidChangeModel(function (e) {
      _this._undoStack = [];
      _this._redoStack = [];
    }));

    _this._register(editor.onDidChangeModelContent(function (e) {
      _this._undoStack = [];
      _this._redoStack = [];
    }));

    _this._register(editor.onDidChangeCursorSelection(function (e) {
      if (_this._isCursorUndoRedo) {
        return;
      }

      if (!e.oldSelections) {
        return;
      }

      if (e.oldModelVersionId !== e.modelVersionId) {
        return;
      }

      var prevState = new CursorState(e.oldSelections);

      var isEqualToLastUndoStack = _this._undoStack.length > 0 && _this._undoStack[_this._undoStack.length - 1].cursorState.equals(prevState);

      if (!isEqualToLastUndoStack) {
        _this._undoStack.push(new StackElement(prevState, editor.getScrollTop(), editor.getScrollLeft()));

        _this._redoStack = [];

        if (_this._undoStack.length > 50) {
          // keep the cursor undo stack bounded
          _this._undoStack.shift();
        }
      }
    }));

    return _this;
  }

  _createClass(CursorUndoRedoController, [{
    key: "cursorUndo",
    value: function cursorUndo() {
      if (!this._editor.hasModel() || this._undoStack.length === 0) {
        return;
      }

      this._redoStack.push(new StackElement(new CursorState(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft()));

      this._applyState(this._undoStack.pop());
    }
  }, {
    key: "cursorRedo",
    value: function cursorRedo() {
      if (!this._editor.hasModel() || this._redoStack.length === 0) {
        return;
      }

      this._undoStack.push(new StackElement(new CursorState(this._editor.getSelections()), this._editor.getScrollTop(), this._editor.getScrollLeft()));

      this._applyState(this._redoStack.pop());
    }
  }, {
    key: "_applyState",
    value: function _applyState(stackElement) {
      this._isCursorUndoRedo = true;

      this._editor.setSelections(stackElement.cursorState.selections);

      this._editor.setScrollPosition({
        scrollTop: stackElement.scrollTop,
        scrollLeft: stackElement.scrollLeft
      });

      this._isCursorUndoRedo = false;
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(CursorUndoRedoController.ID);
    }
  }]);

  return CursorUndoRedoController;
}(Disposable);
CursorUndoRedoController.ID = 'editor.contrib.cursorUndoRedoController';
export var CursorUndo = /*#__PURE__*/function (_EditorAction) {
  _inherits(CursorUndo, _EditorAction);

  var _super2 = _createSuper(CursorUndo);

  function CursorUndo() {
    _classCallCheck(this, CursorUndo);

    return _super2.call(this, {
      id: 'cursorUndo',
      label: nls.localize('cursor.undo', "Cursor Undo"),
      alias: 'Cursor Undo',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 51
        /* KEY_U */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(CursorUndo, [{
    key: "run",
    value: function run(accessor, editor, args) {
      CursorUndoRedoController.get(editor).cursorUndo();
    }
  }]);

  return CursorUndo;
}(EditorAction);
export var CursorRedo = /*#__PURE__*/function (_EditorAction2) {
  _inherits(CursorRedo, _EditorAction2);

  var _super3 = _createSuper(CursorRedo);

  function CursorRedo() {
    _classCallCheck(this, CursorRedo);

    return _super3.call(this, {
      id: 'cursorRedo',
      label: nls.localize('cursor.redo', "Cursor Redo"),
      alias: 'Cursor Redo',
      precondition: undefined
    });
  }

  _createClass(CursorRedo, [{
    key: "run",
    value: function run(accessor, editor, args) {
      CursorUndoRedoController.get(editor).cursorRedo();
    }
  }]);

  return CursorRedo;
}(EditorAction);
registerEditorContribution(CursorUndoRedoController.ID, CursorUndoRedoController);
registerEditorAction(CursorUndo);
registerEditorAction(CursorRedo);